import styles from './AfegirBloc.module.scss';
import CardRounded from '../CardRounded/CardRoundedComponent';
import FileTree from '../FileTree/FileTreeComponent';
import Breadcrumbs from '../Breadcrumbs/BreadcrumbsComponent';
import PanelColumn from '../PanelColumn/PanelColumnComponent';
import RightSidePanelContent from '../RightSidePanelContent/RightSidePanelContentComponent';
import Flex from '../Flex/FlexComponent';
import AfegirBlocImatgeComponent from '../AfegirBlocImatge';
import EditarBlocComponent from '../EditarBloc';
import { useRedl } from 'hooks/useRedl';
import { useDelivertyUser } from 'hooks/useDelivertyUser';

export default function AfegirBlocComponent() {
    const { showRightSidePanel, setShowRightSidePanel} = useRedl();
    const { userData } = useDelivertyUser();

    return (
        <RightSidePanelContent title="Escull el mòdul pre-configurat" closed>
            <Flex container columnGap="8px" flex="1" position="relative" overflow="hidden">
                <PanelColumn length={1} size={showRightSidePanel?.size} visible>
                    <CardRounded height="100%">
                        <ul className={styles.redlFileTree}>
                            <FileTree pathname="redl" title={[]} userId={userData.usuari} />
                        </ul>
                    </CardRounded>
                </PanelColumn>

                <PanelColumn visible={showRightSidePanel?.size === 'lg' || showRightSidePanel?.size === 'xl'} size={showRightSidePanel?.size} length={1}
                             sibling>
                    <CardRounded height="100%" action="add" closed
                                 header={<Breadcrumbs breadcrumbs={showRightSidePanel?.data?.breadcrumbs || showRightSidePanel?.allData?.breadcrumbs} />}>
                        <div className={styles.redlAfegirBlocImatgeWrapper}>
                            {(showRightSidePanel?.data?.essence || showRightSidePanel?.allData?.essence)?.map(d => (
                                <AfegirBlocImatgeComponent
                                    key={d.thumbnail}
                                    data={d}
                                    onClick={() => setShowRightSidePanel(prevState => ({
                                        ...prevState,
                                        size: 'xl',
                                        action: 'addDefault',
                                        data: d,
                                        fontDeDades: undefined,
                                        allData: showRightSidePanel?.data?.essence ? showRightSidePanel?.data : prevState.allData
                                    }))}  />
                            ))}
                        </div>
                    </CardRounded>
                </PanelColumn>
                <PanelColumn visible={showRightSidePanel?.action === 'addDefault'} size={showRightSidePanel?.action === 'addDefault' ? 'xl':null} length={3}
                             sibling>
                    <CardRounded height="100%" closed onCancel={() => { 
                            setShowRightSidePanel(prevState => ({ ...prevState, size: 'lg', data: prevState.allData, action: 'add' }))}}>
                        <EditarBlocComponent />
                    </CardRounded>
                </PanelColumn>
                
            </Flex>
        </RightSidePanelContent>
    );
}